<template>
	<div class="overflowxHidden">

	   	<div class="page-back-btn" v-if="!$route.query.hotelId" onclick="window.history.go(-1)">
            <i class="iconfont icon-yuyin"></i>
       	</div>
	   	<div class="page-back-btn" v-if="$route.query.hotelId" @click="$router.push('/')">
            <i class="iconfont icon-yuyin"></i>
       	</div>
	    <div class="lmy-product-detail">
	      <div class="banner" v-if="details" >
					<Swipe class="index-cal" style="height:200px;" v-if="details.Pics&&details.Pics.length>0">
						<SwipeItem  v-for="img in details.Pics" :key="img.Url" >
							<img :src="img.Url | replaceImgSrc(4)" :alt="img.Name" style="width:100%;height:200px"  />
						</SwipeItem>

					</Swipe>
					<Swipe class="index-cal" style="height:200px;"  v-if="!details.Pics||details.Pics.length<=0">

						<SwipeItem  v-show="details.Pics&&details.Pics.length<=0">
							<img src="./../../assets/img/hotelDetailsDf.png" style="width:100%;height:200px"/>
						</SwipeItem>
					</Swipe>
	            <!-- <div class="banner-btm">
	                <div class="collect">
	                	<i class="iconfont icon-shoucang1" v-if="!isHotelCorrect"  @click="saveHotel(details)"></i>
	                	<i class="iconfont icon-shoucang"  v-if="isHotelCorrect" @click="unsaveHotel(details)"></i>
	                </div>
	            </div> -->
	        </div>
			<div class="hotel-intro">
				<div class="topic" v-if="details">
					<div class="hotel-title">
						{{details.HotelName||''}}
						<span class="type" v-if="details.Star<=3">经济型</span>
						<span class="type" v-if="details.Star>3 && details.Star<=5">舒适型</span>
						<span class="type" v-if="details.Star>5 && details.Star<=7">高档型</span>
						<span class="type" v-if="details.Star>7">豪华型</span>
					</div>
					<p class="facility-year">{{details.BuildOn?(details.BuildOn.split('-')[0])+'年开业':''}}  {{details.LastDecorationOn?(details.LastDecorationOn.split('-')[0])+'年装修':''}}</p>
					<span class="right-bar" @click="routeToReadme">详情/设施<i class="iconfont icon-more"></i></span>
				</div>


				<div class="address" v-if="details">
					<span class="right-bar" v-if="this.MyLon&&this.MyLat" @click="routeToMap(details)">地图/周边<i class="iconfont icon-more"></i></span>
					<p>{{details.Address}} <span class="region" v-if="details.DistrictName||details.Landmark">{{details.DistrictName||''}}</span></p>
					<p class="region" v-if="details.Landmark">{{details.Landmark||''}}</p>
					<p class="detail-address" v-if="details.SubwayInfo">{{details.SubwayInfo||''}}</p>

					<p class="detail-address" v-if="details.Distance">{{details.Distance||''}}</p>
				</div>

				<div class="grade" v-if="details">
					<span class="score">{{details.CommRate}}</span>

					<div class="grade-detail" >
						<p class="score-total" v-if="details.Evaluation||details.CommRate">{{details.Evaluation}} 综合评分{{details.CommRate}}/5分</p>
						<p class="score-detail">
							<span v-if="details.SurroundRate">位置 {{details.SurroundRate}}</span>
							<span v-if="details.FacilityRate">设施 {{details.FacilityRate}}</span>
							<span v-if="details.ServiceRate">服务 {{details.ServiceRate}}</span>
							<span v-if="details.CleanRate">卫生 {{details.CleanRate}}</span>
						</p>
					</div>
					<!-- <div class="share">
						<i class="iconfont icon-erweima"></i>
						<span class="text">赚佣金</span>
					</div> -->
				</div>
	        </div>
			<!-- 国内-->
	        <div class="select-bar" v-if="details" >
				<div class="select-item">
					<div class="select-date" @click="calendar.show=true">
						<span>入住 </span>{{CheckIn|dateShort}}
						<span class="day">{{getDays(CheckIn,CheckOut)}}晚</span>
						<span>离店 </span>{{CheckOut|dateShort}}
					</div>
					<div class="line"></div>
					<div class="select-people"  @click="controlSelectPage(true,'房间数',RoomCount)">
						{{RoomCount}}间
						<i class="iconfont icon-more"></i>
					</div>
				</div>
	        </div>

	        <!-- 房间列表 -->
	        <div class="room-list"  v-for="(room ,$index) in details.Rooms" @click="openPrice(room,$index)" v-show="$index<listShowLenght&&!isLoading">

				<i class="iconfont icon-yishouqing" v-if="!room.Available"></i>
	            <div class="list-item">
					<div class="title-box">
	                	<h5 class="room-title">{{room.RoomName}}</h5>
						<!-- <span class="high-Rebate-price " >
							最高返佣¥{{room.MaxRebate}}
						</span> -->
					</div>
	                <p class="room-info">
	                	{{(room.RoomSize>0?(room.RoomSize+'㎡'):'')}}
	                	{{room.Floor>0?(room.Floor+'层 '):''}}
						<label v-if="room.Window==0">部分有窗</label>
						<label v-if="room.Window==1">有窗</label>
						<label v-if="room.Window==2">无窗</label>
						<label v-if="room.Net==0">无网络</label>
						<label v-if="room.Net==1">宽带</label>
						<label v-if="room.Net==2">WIFI</label>
	                </p>

					<p class="room-info"> <label>{{room.Bed}}</label></p>
					<p class="room-info"><label>{{room.Breakfast}}</label></p>

	                <div class="room-price" v-if="room.LowestPrice">
	                	¥<span class="num">{{room.LowestPrice|numberFloatDel}}</span><span class="start">起</span>
					<i :class="room.active?'xiala active':'xiala'"></i>

	                </div>
	                <div class="room-price" v-if="!room.LowestPrice">暂无价格</div>
	            </div>
	            <!-- 房间列表子列表 -->
	            <ul class="list-sub-item" v-show="room.active">
	                <li v-for="price in room.Prices" @click="book(room,price,$event)" class="list-si-li">
	                    <div class="room-title">
							<div>{{price.RPName}}</div>
	                    	<div class="hotel-num">
								<div class="count " v-if="price.Stock>=5&&price.Tip!=6">
									房量充足
								</div>
								<div class="count " v-if="price.Stock<5&&price.Stock>0&&price.Tip!=6">
									仅剩<span>{{price.Stock}}</span>间
								</div>
								<div v-if="price.Tip==6">
									售罄
								</div>
							</div>
	                    </div>

	                    <p class="room-info">{{price.CancelPolicy}}</p>
						<div class="list-si-li-img">

						</div>
						<div class="status">
							<span class="price-tags" v-if="(price.Attr & 1)==1">连住优惠</span>
							<span class="price-tags" v-if="(price.Attr & 2)==2">早鸟优惠</span>
							<span class="price-tags" v-if="(price.Attr & 3)==3">团房优惠</span>
						</div>
	                    <div class="price">
							¥<span class="num">{{price.AdultPrice|numberFloatDel}}</span>
							<!-- <span class="Rebate-price">返佣¥{{price.Rebate}}</span> -->
						</div>
						<div class="book-btn-box">
							<div  :class="price.Tip==1||price.Tip==0?'book-btn':'book-btn disabled'">预订</div>
	                    	<div class="status" v-if="price.Tip==0">立即确认</div>

							<div class="status fr-res-type-long"      v-if="price.Tip==1&&dateToday==CheckIn">0.5小时内确认</div>
							<div class="status"      v-if="price.Tip==1&&dateToday!=CheckIn">1小时内确认</div>

							<div class="status"  v-if="price.Tip==3">需提前</div>
							<div class="status"  v-if="price.Tip==4">需连住</div>
							<div class="status"  v-if="price.Tip==5">{{price.MiniRoomCount}}间以上</div>
							<div class="sell-out"  v-if="price.Tip==6">售罄</div>
						</div>
	                </li>

	            </ul>
	        </div>

			<div class="infinite-loading-containers" v-if="isLoading">
				<i class="loading-defaults"></i>
			</div>
			<div class="select-bar" v-if="details.Rooms&&details.Rooms.length==0" style="color:#999;border-bottom:none;text-align:center;padding:50rpx;line-height: 1.5em;">
            该酒店所有房型均已售罄，<br>您可以选择其他酒店预订！
          </div>
			<ul class="home-holte-bottom">
				<li v-if="details.Rooms&&details.Rooms.length<=5&&details.Rooms.length!=0">已全部加载</li>
				<li @click="listShowLenght=details.Rooms.length" v-if="details.Rooms&&details.Rooms.length>5&&listShowLenght==5">查看全部 <i class="iconfont icon-more" ></i></li>
				<li @click="listShowLenght=5" v-if="details.Rooms&&details.Rooms.length>5&&listShowLenght>5">收起 <i class="iconfont icon-more" ></i></li>
			</ul>
	    </div>
		<transition  name="slide" >
			<DatePicker @select="calendar.select" :start="calendar.start" :last="calendar.last" :beginDate="calendar.begin" :endDate="calendar.end" :monthLength="calendar.monthLength"  v-show="calendar.show" ></DatePicker>
		</transition>
		<cnAlert ref="cnAlert"></cnAlert>
	    <!-- <roomAndPerson @select="rpData.select" v-show="rpData.show" :rpData="rpData" ></roomAndPerson> -->
		<transition  name="slide" >
            <selectPage v-if="selectPageType.show" :title="selectPageType.type" :active="selectPageType.active" @getSelectData="getSelectData" @showPage="controlSelectPage"></selectPage>
        </transition>
	</div>
</template>
<script>
// ps:From===1为国内酒店，From==0为国外酒店
import DatePicker from "./../common/cmpnt/datePicker/datePicker.vue"; //日期选择器
import eqmtList from "./../common/equitment.js";
import roomAndPerson from "./../common/cmpnt/roomAndPerson.vue"; //酒店房间和入住人数
import selectPage from "./../common/cmpnt/selectPage.vue"; //选择
import cnAlert from "./../common/cmpnt/cnAlert.vue";

require("vue-swipe/dist/vue-swipe.css");
const { Swipe, SwipeItem } = require("vue-swipe"); //轮播图
export default {
  name: "hotelDetails",
  components: {
    cnAlert,
    Swipe,
    SwipeItem,
    DatePicker,
    roomAndPerson,
    selectPage
  },
  data() {
    return {
      HotelID: "",
      ProductType: 0,
      userInfo: this.dao.get("userInfo")
        ? JSON.parse(this.dao.get("userInfo"))
        : "",
      From: 1,
      dateToday: this.getDate(0),
      RoomCount: 1,
      AdultCount: 2,
      ChildrenCount: 0,
      MyLat: "",
      MyLon: "",
      MyCityRegionID: "",
      eqmtList: eqmtList,
      isLoading: false,
      isIntruduceOpen: false,
      isHotelCorrect: false,
      isRoomCountSelectShow: false,
      isSellingPointShow: false,
      CheckIn: "",
      CheckOut: "",
      calendar: {
        monthLength: 3,
        show: false,
        start: {
          year: this.getDate(0).split("-")[0],
          month: this.getDate(0).split("-")[1],
          day: this.getDate(0).split("-")[2]
        },
        last: {
          year: this.getDate(60).split("-")[0],
          month: this.getDate(60).split("-")[1],
          day: this.getDate(60).split("-")[2]
        },
        begin: {
          year: this.getDate(1).split("-")[0],
          month: this.getDate(1).split("-")[1],
          day: this.getDate(1).split("-")[2]
        },
        end: {
          year: this.getDate(2).split("-")[0],
          month: this.getDate(2).split("-")[1],
          day: this.getDate(2).split("-")[2]
        },

        select: (begin, end) => {
          this.calendar.show = false;
          if (!begin || !end) {
            this.calendar.show = false;
            return;
          }
          this.calendar.begin = begin;
          this.calendar.end = end;
          this.CheckIn = begin.year + "-" + begin.month + "-" + begin.day;
          this.CheckOut = end.year + "-" + end.month + "-" + end.day;
          this.initData();
        }
      },
      rpData: {
        show: false,
        RoomCount: this.dao.get("hotelDetailsParams")
          ? JSON.parse(this.dao.get("hotelDetailsParams")).RoomCount
          : 1,
        AdultCount: this.dao.get("hotelDetailsParams")
          ? JSON.parse(this.dao.get("hotelDetailsParams")).AdultCount
          : 2,
        ChildrenCount: this.dao.get("hotelDetailsParams")
          ? JSON.parse(this.dao.get("hotelDetailsParams")).ChildrenCount
          : 0,
        ChildrenAges: this.dao.get("hotelDetailsParams")
          ? JSON.parse(this.dao.get("hotelDetailsParams")).ChildrenAges
          : "",
        from: 1,
        select: val => {
          this.rpData.show = false;
          this.RoomCount = val.RoomCount;
          this.AdultCount = val.AdultCount;
          this.ChildrenCount = val.ChildrenCount;
          this.ChildrenAges = val.ChildrenAges;
          this.initData();
        }
      },
      details: "",
      selectPageType: { show: false, type: "房间数", active: "" },
      listShowLenght: 5 //显示房价个数，默认2个
    };
  },
  methods: {
    getCheckIn() {
      if (this.$route.query.CheckIn) {
        var queryIn = new Date(this.$route.query.CheckIn);
        var nowDate = new Date(this.getDate(0));
        if (queryIn < nowDate) {
          this.CheckIn = this.getDate(0);
        } else {
          this.CheckIn = this.$route.query.CheckIn;
        }
      } else {
        var udetail = this.dao.get("hotelDetailsParams");
        if (udetail) {
          this.CheckIn = JSON.parse(udetail).CheckIn;
        } else {
          this.CheckIn = this.getDate(0);
        }
      }
    },
    getCheckOut() {
      if (this.$route.query.CheckIn) {
        var queryOut = new Date(this.$route.query.CheckOut);
        var nowDate = new Date(this.getDate(0));
        if (queryOut > nowDate) {
          this.CheckOut = this.$route.query.CheckOut;
        } else {
          this.CheckOut = this.getDate(1);
        }
      } else {
        var udetail = this.dao.get("hotelDetailsParams");
        if (udetail) {
          this.CheckOut = JSON.parse(udetail).CheckOut;
        } else {
          this.CheckOut = this.getDate(1);
        }
      }
    },

    // 显示-隐藏 选项页
    controlSelectPage(bool, type, active) {
      this.selectPageType.show = bool;
      if (type) {
        this.selectPageType.type = type;
        this.selectPageType.active = active;
      }
    },
    // 获得选项信息
    getSelectData(item, type) {
      if (type == "房间数") {
        this.RoomCount = item.value;
        this.initData();
      }
    },
    initData() {
      var that = this;
      var params = {
        HotelID: this.HotelID,
        ProductType: 0,
        From: this.From,
        CheckIn: this.CheckIn,
        CheckOut: this.CheckOut,
        RoomCount: this.RoomCount,
        AdultCount: this.AdultCount,
        ChildrenCount: this.ChildrenCount,
        MyLat: this.MyLat,
        MyLon: this.MyLon,
        MyCityRegionID: this.MyCityRegionID
      };
      this.isLoading = true;
      that
        .postRequest({
          url: that.Api.hotel,
          params: params
        })
        .then(res => {
          this.isLoading = false;
          if (res && res.IsSuccess) {
            that.details = res.Result;
            var option = res.Result.ShareInfo;
            that.setConfigShare(option);
            that.$nextTick(function() {
              //  that.initCanvas();
            });
          } else {
            that.details = "";
          }
        });
    },
    routeToReadme() {
			console.log(JSON.stringify(this.details.Landmarks))
			console.log(JSON.stringify(this.details))
      this.dao.set("mapLamndmarks", JSON.stringify(this.details.Landmarks));
      this.dao.set("hotelReadmeView", JSON.stringify(this.details));
      this.$router.push("/hotelView");
    },
    // //取消收藏酒店
    // unsaveHotel(hotel){
    // 	var that=this;
    //         var param={
    //             ID:that.HotelID,
    //         }
    //         that.getRequest({
    //             url:that.Api.removeFavorite,
    //             params:param
    //         }).then(res => {
    //             if(res){
    //             	that.isHotelCorrect=false;
    // 			this.$alert('取消收藏成功')
    //             }
    //         });
    // },
    // //收藏酒店
    // saveHotel(hotel){
    // 	var that=this;
    //       var param={
    //           ID:that.HotelID,
    //           Name:hotel.HotelName||hotel.HotelEName,
    //           From:that.From,
    //           ProductType:that.ProductType,
    //       }
    //       that.postRequest({
    //           url:that.Api.addFavorite,
    //           params:param
    //           }).then(res => {
    //             if(res){
    //             	that.isHotelCorrect=true;
    // 				that.$alert('收藏成功')
    //             }
    //       });
    // },
    isFavoriteExist() {
      var that = this;
      var promise = new Promise(function(resolve, reject) {
        var param = {
          id: that.HotelID
        };
        that
          .getRequest({
            url: that.Api.isFavoriteExist,
            params: param,
            isAnonymous: true
          })
          .then(res => {
            if (res && res == true) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
      });

      promise.then(
        function(value) {
          that.isHotelCorrect = value;
        },
        function(value) {
          // failure
          that.isHotelCorrect = false;
        }
      );
    },
    routeToMap(hotel) {
      if (!hotel.Lat || !hotel.Lon) {
        this.error({ title: "提示", content: "该酒店没有位置信息！" });
        return;
      }
      this.dao.set("mapLandmarks", JSON.stringify(hotel.Landmarks));
      this.$router.push({
        path: "/baiduMap",
        query: {
          lng: hotel.Lon,
          lat: hotel.Lat,
          m1: this.MyLon,
          m2: this.MyLat,
          HotelName: hotel.HotelName,
          hotelId: this.HotelID
        }
      });
    },
    getDefaultDate(da) {
      var date = new Date(da);
      // date.setDate(date.getDate() + count); //获取count天后的日期
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      var time = year + "-" + month + "-" + day;
      return time;
    },

    openPrice: function(item, index, $event) {
      var that = this;
      this.$nextTick(function() {
        this.$set(item, "active", item.active ? false : true);
      });
    },
    initCanvas() {
      var num = this.details.CommRate;
      var w = document.getElementsByClassName("grade-percent");
      var c = document.getElementById("canvas");
      var score = document.getElementById("score");

      score.style.marginTop = "-" + parseInt(score.offsetHeight / 2) + "px";
      score.style.marginLeft = "-" + parseInt(score.offsetWidth / 2) + "px";
      var ctx = c.getContext("2d");
      var width = w[0].offsetWidth;
      var height = w[0].offsetHeight;
      if (window.devicePixelRatio) {
        c.style.width = width + "px";
        c.style.height = height + "px";
        c.height = height * window.devicePixelRatio;
        c.width = width * window.devicePixelRatio;
        ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
      }
      var centerX = w[0].offsetWidth / 2; //Canvas中心点x轴坐标
      var centerY = w[0].offsetHeight / 2; //Canvas中心点y轴坐标
      var rad = (Math.PI * 2) / 100; //将360度分成100份，那么每一份就是rad度

      drawCircle(ctx, (num / 5) * 100);
      function drawCircle(ctx, percent) {
        //画白色的静态圆
        ctx.save();
        ctx.strokeStyle = "#ccc";
        ctx.shadowColor = "#fff";
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.arc(centerX, centerY, centerX - 3, 0, Math.PI * 2, true);
        ctx.stroke();
        ctx.closePath();
        ctx.restore();

        //画进度环
        ctx.save();
        ctx.strokeStyle = "#fd6e12";
        ctx.shadowColor = "#fff";
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.arc(
          centerX,
          centerY,
          centerX - 3,
          -Math.PI / 2,
          -Math.PI / 2 + percent * rad,
          false
        );
        ctx.stroke();
        ctx.closePath();
        ctx.restore();
      }
    },
    book(room, price, $event) {
      $event.stopPropagation();
      var that = this;
      //缓存酒店token
      var hotelToken = "";
      var obj = that.details;

      if (price.Tip > 1) {
        that.error({ title: "不能预订", content: price.Errors });
        return;
      }
      var roomCount =''
      if(!price.IsAskRoom){
        roomCount = that.RoomCount <= price.Stock ? that.RoomCount : price.Stock
      }else{
        roomCount = that.RoomCount
      }
      var obj1 = {
        From: that.From,
        HotelName: obj.HotelName,
        RoomName: room.RoomName,
        RPName: price.RPName,
        CheckIn: that.CheckIn,
        CheckOut: that.CheckOut,
        RoomCount: roomCount,
        Star: obj.Star,
        HotelAddress: obj.Address,
        HotelPhone: obj.Phone,
        AdultPrice: price.AdultPrice,
        days: that.getDays(that.CheckIn, that.CheckOut),
        Token: price.Token,
        CancelPolicy: price.CancelPolicy,
        Breakfast: price.Breakfast,
        Currency: price.Currency,
        Tip: price.Tip,
        // Breakfast:price.Breakfast,
        DailyRates: price.DailyRates,
        AvgPrice: price.AvgPrice,
        Stock: price.Stock
      };
      hotelToken = price.Token;
      that.dao.set("bookInfo", JSON.stringify(obj1));

      //检查是否可以预订
      this.checkBookAble(hotelToken, function() {
        that.$router.push("/book");
      });
    },
    // 检查是否可以预订
    checkBookAble(token, callback) {
      var that = this;
      // 单独控制
      that.$refs.cnAlert.massage = "正在查询酒店库存信息，请稍候";
      that.$refs.cnAlert.isAlert = true;
      var param = {
        token: token
      };
      that
        .postRequest({
          url: that.Api.checkBookable,
          params: param
        })
        .then(res => {
          that.$refs.cnAlert.massage = "";
          that.$refs.cnAlert.isAlert = false;
          //当IsSuccess==true时，表示有库存可以预订
          if (res) {
            if (res.IsSuccess) {
              callback();
            } else {
              this.error({ title: "提示", content: res.Msg || "不能预订" });
            }
          }
        });
    },
    // 计算日期差
    getDays(s1, s2) {
      s1 = new Date(s1.replace(/-/g, "/"));
      s2 = new Date(s2.replace(/-/g, "/"));

      var days = s2.getTime() - s1.getTime();
      var time = parseInt(days / (1000 * 60 * 60 * 24));
      return time;
    },
    initParam() {
			if (this.dao.get("hotelDetailsParams")) {
        this.HotelID = JSON.parse(this.dao.get("hotelDetailsParams")).HotelID;
        this.From = JSON.parse(this.dao.get("hotelDetailsParams")).From || 1;
        this.RoomCount =
          JSON.parse(this.dao.get("hotelDetailsParams")).RoomCount || 1;
        this.AdultCount =
          JSON.parse(this.dao.get("hotelDetailsParams")).AdultCount || 2;
        this.ChildrenCount =
          JSON.parse(this.dao.get("hotelDetailsParams")).ChildrenCount || 0;
        this.MyLat =
          JSON.parse(this.dao.get("hotelListSearchParams")).MyLat || "";
        this.MyLon =
          JSON.parse(this.dao.get("hotelListSearchParams")).MyLon || "";
        this.MyCityRegionID =
          JSON.parse(this.dao.get("hotelListSearchParams")).MyCityRegionID ||
          "";
      } else if (this.$route.query.hotelId) {
        this.HotelID = this.$route.query.hotelId;
        this.From = this.$route.query.from||1;
      }
			var CheckIn = this.CheckIn;
      var CheckOut = this.CheckOut;
				if(CheckIn && CheckOut){
					this.calendar.begin = {
					year: CheckIn.split("-")[0],
					month: CheckIn.split("-")[1],
					day: CheckIn.split("-")[2]
				};
				this.calendar.end = {
					year: CheckOut.split("-")[0],
					month: CheckOut.split("-")[1],
					day: CheckOut.split("-")[2]
				};
			}
      
			this.initData();
    }
  },
  created() {
    this.getCheckIn();
    this.getCheckOut();
  },
  mounted() {
    var userInfo = this.dao.get("userInfo")
      ? JSON.parse(this.dao.get("userInfo"))
      : "";
    if (userInfo.CustomerNO) {
      this.isFavoriteExist();
    }
    this.initParam();
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/hotel/details.vue